/**
 * Shared constants and types for the device configuration feature.
 *
 * Extracted from DevicesPage so both the page (edit/delete flows) and the
 * add-device flow (useAddDeviceFlow / AddDeviceForm) share a single source.
 */
import { DeviceType } from '../../types/devices';

export interface DeviceCredentials {
  // Apex Fusion / AquaWiz / Focustronic (username/password)
  username?: string;
  password?: string;
  // Alternative for Focustronic (email/password)
  email?: string;
  // Aquarimate (API key only)
  api_key?: string;
  // Aquarimate multi-source options
  enable_water_tests?: boolean;
  enable_maintenance?: boolean;
  // AquaWiz device selection
  device_id?: string;
}

export interface CreateDeviceData {
  device_type: DeviceType;
  display_name: string;
  credentials: DeviceCredentials;
}

export const DEVICE_TYPE_OPTIONS = [
  { value: 'apex_fusion', label: 'Apex Fusion (Cloud)' },
  { value: 'focustronic', label: 'Focustronic (Alkatronic, Dosetronic, Mastertronic)' },
  { value: 'aquawiz', label: 'AquaWiz KH1' },
  { value: 'aquarimate', label: 'Aquarimate' },
  { value: 'kamoer_kh', label: 'Kamoer (KH Carer / STP / P4 Pro)' },
];

// Kamoer device types whose credentials are managed via provider accounts
export const KAMOER_DEVICE_TYPES: DeviceType[] = ['kamoer_kh', 'kamoer_stp', 'kamoer_p4'];
